export default "__VITE_ASSET__DcwKpeiY__"